import { useEffect } from 'react';

const usePageMetadata = (title, favicon) => {
	useEffect(() => {
		// Set the document title
		document.title = title;

		// Set the favicon
		if (favicon) {
			let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			link.type = 'image/x-icon';
			link.rel = 'shortcut icon';
			link.href = favicon;

			// If it's a new link element, append it to the head
			if (!document.querySelector("link[rel*='icon']")) {
				document.getElementsByTagName('head')[0].appendChild(link);
			}
		}
	}, [title, favicon]);
};

export default usePageMetadata;
